import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent } from "@angular/material/dialog";
import { ModalHeaderComponent } from '../../../layout/modal-header/modal-header.component';
import {NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSlideToggle } from '@angular/material/slide-toggle';

@Component({
    selector: 'app-are-you-sure',
    templateUrl: './are-you-sure.component.html',
    styleUrls: ['./are-you-sure.component.scss'],
    imports: [ModalHeaderComponent, MatDialogContent, NgIf, FormsModule, NgSwitch, NgSwitchCase, NgSwitchDefault, MatSlideToggle]
})
export class AreYouSureComponent implements OnInit {
  input = ''
  toggled = false
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      extraConfirmation: boolean,
      section: string,
      /** Optional caller-supplied line rendered under the section copy, for confirmations whose
       *  wording depends on runtime values (e.g. "This will replay 47 runs..."). */
      detail?: string,
      /** Label for an optional opt-in switch; when set, the modal closes with `{toggled}` instead of `true`. */
      toggle?: string
    },
    public dialogRef: MatDialogRef<AreYouSureComponent>
  ) {
  }

  ngOnInit(): void {
  }

  confirm() {
    if ((this.data.extraConfirmation && this.input.toUpperCase() === 'DELETE') || !this.data.extraConfirmation) {
      this.dialogRef.close(this.data.toggle ? {toggled: this.toggled} : true)
    }
  }

}
